import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=dark%20luxury%20cinema%20theater%20hall%20with%20red%20velvet%20seats%2C%20golden%20stage%20curtains%2C%20warm%20dramatic%20lighting%2C%20empty%20elegant%20movie%20theater%20interior%2C%20cinematic%20atmosphere%2C%20dark%20and%20warm%20tones&width=1800&height=900&seq=hero-cinema-bg&orientation=landscape"
        alt="琪琪影院 - 电影大全在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/30 to-foreground-950/70"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
          电影大全 <span className="text-accent-400">免费在线看</span>
        </h1>
        <p className="text-sm md:text-base text-background-50/80 max-w-2xl mb-8 leading-relaxed">
          最新电影热门电影一网打尽，科幻电影动作电影高清蓝光画质免费看不缓冲，海量片库持续更新。
        </p>
        <div className="flex items-center gap-3 flex-wrap justify-center">
          <Link
            to="/category/action"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-fill mr-2"></i>立即观影
          </Link>
          <Link
            to="/category/sci-fi"
            className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm md:text-base hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            科幻电影
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm md:text-base hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            关于琪琪
          </Link>
        </div>
        <div className="mt-10 flex items-center gap-6 flex-wrap justify-center">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">50000+</div>
            <div className="text-xs md:text-sm text-background-50/60">电影资源</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">800万+</div>
            <div className="text-xs md:text-sm text-background-50/60">累计用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">蓝光4K</div>
            <div className="text-xs md:text-sm text-background-50/60">高清画质</div>
          </div>
        </div>
      </div>
    </section>
  );
}